module.exports = __webpack_public_path__ + "static/media/illustrator.08b4db97.svg";